import type { FernieMicroVariant } from "~/components/fernie/fernieMarkRules";

import { resolveFernieMark } from "~/components/fernie/fernieMarkRules";

export type FernieToneContext = "confirm" | "failure" | "money" | "neutral" | "retry" | "success";

export type FernieSurface = "document" | "grid" | "panel";

const NO_CHARACTER_TONES: readonly FernieToneContext[] = ["money", "confirm", "failure"];
const NO_FACE_SURFACES: readonly FernieSurface[] = ["grid", "document"];

export const forbidsCharacter = (tone: FernieToneContext): boolean => NO_CHARACTER_TONES.includes(tone);

export const forbidsFace = (surface: FernieSurface): boolean => NO_FACE_SURFACES.includes(surface);

export type GovernedMark =
	| { mark: "none" }
	| { mark: "eyes" }
	| { mark: "micro"; variant: FernieMicroVariant }
	| { mark: "face"; grin: boolean };

export interface GovernMarkInput {
	size: number;
	surface?: FernieSurface;
	tone?: FernieToneContext;
}

export const governMark = ({ size, surface = "panel", tone = "neutral" }: GovernMarkInput): GovernedMark => {
	if (forbidsFace(surface)) return { mark: "none" };
	const base = resolveFernieMark(size);
	if (base === "eyes") return { mark: "eyes" };
	if (base === "micro") return forbidsCharacter(tone) ? { mark: "eyes" } : { mark: "micro", variant: "smile" };
	return { mark: "face", grin: !forbidsCharacter(tone) };
};
